(function(iz) {
	iz.GetProgrami = GetProgrami;
	iz.GetProgramiIzbornik = GetProgramiIzbornik;
	iz.ProgramiIzbornikUpisi = ProgramiIzbornikUpisi;
	
	function GetProgrami(poduzece, samoWeb) {
		samoWeb = typeof samoWeb === 'boolean' ? samoWeb : true;
		
		return $.dsDirectCall({
			method: "GetProgrami",
			params: [poduzece, samoWeb]
		});	
	}

	function GetProgramiIzbornik(programiId) {
		return $.dsDirectCall({
			method: "GetProgramiIzbornik",
			params: [programiId]
		});
	}

	function ProgramiIzbornikUpisi(podaci) {
		return $.dsDirectCall({
			method: "ProgramiIzbornikUpisi",
			params: [podaci],
			type: "POST"
		});
	}
	
	function GetPopisGrupaKor(){
		return $.dsDirectCall({
			method: "iz/GetPopisGrupaKor"
		});		
	}
}(konto.iz));